import { render, staticRenderFns } from "./CharityBar.vue?vue&type=template&id=244b370a&scoped=true&lang=pug"
import script from "./CharityBar.vue?vue&type=script&lang=js"
export * from "./CharityBar.vue?vue&type=script&lang=js"
import style0 from "./CharityBar.vue?vue&type=style&index=0&id=244b370a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b370a",
  null
  
)

export default component.exports